<template>
  <div class="register">
    <div class="titulo">
      <h1>Crie Sua Conta</h1>
      <p>
        Queremos te conhecer melhor, para que assim a gente possa cuidar muito bem de você,
        dos seus clientes e também das suas cobranças.
      </p>
    </div>

    <div class="card-box full">
      <br>
      <form @submit="submitHandler" autocomplete="off">
        <div class="linha">
          <div class="eight">
            <label>Seu nome completo</label>
            <input type="text" placeholder="Digite aqui" v-model="form.name" maxlength="100"/>
          </div>
          <div class="eight">
            <label>CPF</label>
            <the-mask :mask="MASK_CPF"
                      placeholder="Digite somente números"
                      v-model="form.document"/>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>Seu e-mail</label>
            <input type="text" placeholder="seu@email.com" v-model="form.email" maxlength="200"/>
          </div>
          <div class="eight">
            <label>Seu celular</label>
            <the-mask :mask="[MASK_PHONE_BR, MASK_PHONE_BR_ADG]"
                      placeholder="Digite somente números"
                      v-model="form.phone"/>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>Sua senha</label>
            <input type="password" placeholder="Escolha uma bem difícil" v-model="form.password"/>
          </div>
          <div class="eight">
            <label>Confirme a sua senha</label>
            <input type="password"
                   placeholder="Deve ser igual a senha ao lado"
                   class="password"
                   v-model="form.passwordConfirm"/>
          </div>
        </div>

        <div class="erroDados" v-if="!passwordConfirmed">
          As senhas devem ser iguais
        </div>

        <div class="erroDados" v-if="form.password && !passwordIsValid">
          Senha inválida.
          <br/>
          <br/>
          A senha deve conter:
          <br/>
          &nbsp;- Uma letra maiúscula<br/>
          &nbsp;- Uma letra minúscula<br/>
          &nbsp;- Um número<br/>
          &nbsp;- Um caractere especial<br/>
          &nbsp;- No mínimo 8 dígitos<br/>
        </div>

        <div class="erroDados" v-if="form.document && !documentIsValid">
          O CPF é inválido.
        </div>

        <div class="erroDados" v-if="form.email && !emailIsValid">
          E-mail inválido.
        </div>

        <div class="erroDados" v-if="form.phone && !phoneIsValid">
          Celular inválido.
        </div>

        <div class="erroDados" v-if="loginState === STATE_NOT_AVAILABLE">
          Este e-mail já está sendo usado por outro usuário.
        </div>

        <div class="erroDados" v-if="documentState === STATE_NOT_AVAILABLE">
          Este CPF já está sendo usado por outro usuário.
        </div>

        <ContinueSection enable-back
                         :enable-continue="enableSubmit"
                         @back="$emit('back')"/>
      </form>
    </div>
  </div>
</template>

<script>
import isValidCpf                      from '@brazilian-utils/is-valid-cpf'
import isValidPhone                    from '@brazilian-utils/is-valid-phone'
import isValidEmail                    from '@/common/utils/isValidEmail'
import validatePassword                from '@/common/utils/password'
import Info                            from '@/components/Info'
import ContinueSection                 from '@/components/ContinueSection'
import { verifyLogin, verifyDocument } from '@/common/lib/api'

const STATE_CHECKING = 'CHECKING'
const STATE_AVAILABLE = 'AVAILABLE'
const STATE_NOT_AVAILABLE = 'NOT_AVAILABLE'

let loginTimeoutID = null
let documentTimeoutID = null

export default {
  name: 'Register',
  components: {
    ContinueSection,
    Info
  },
  model: {
    prop: 'owner',
    event: 'submit'
  },
  props: {
    personType: String,
    owner: Object
  },
  data: () => ({
    STATE_NOT_AVAILABLE,
    documentState: STATE_AVAILABLE,
    loginState: STATE_AVAILABLE,
    form: {
      name: '',
      document: '',
      email: '',
      phone: '',
      password: '',
      passwordConfirm: ''
    }
  }),
  methods: {
    submitHandler(e) {
      e.preventDefault()

      const { personType, form } = this

      const data = Object.assign({}, form, { personType, email: form.email.trim().toLowerCase() })

      this.$emit('submit', data)

      return false
    }
  },
  computed: {
    enableSubmit() {
      const {
        form,
        passwordConfirmed,
        documentIsValid,
        emailIsValid,
        phoneIsValid,
        loginState,
        documentState
      } = this

      const {
        name, document, email, phone, password, passwordConfirm
      } = form

      return !!(
        name
        && email
        && phone
        && document
        && password
        && emailIsValid
        && phoneIsValid
        && documentIsValid
        && passwordConfirm
        && passwordConfirmed
        && loginState === STATE_AVAILABLE
        && documentState === STATE_AVAILABLE
      )
    },
    documentIsValid() {
      return isValidCpf(this.form.document)
    },
    emailIsValid() {
      return isValidEmail(this.form.email)
    },
    phoneIsValid() {
      return isValidPhone(this.form.phone)
    },
    passwordIsValid() {
      return validatePassword(this.form.password)
    },
    passwordConfirmed() {
      const { password, passwordConfirm } = this.form

      return passwordConfirm === password
    }
  },
  watch: {
    owner(owner) {
      setTimeout(() => {
        this.form = owner
      }, 1000)
    },
    'owner.email': function (login) {
      this.loginState = STATE_CHECKING
      clearTimeout(loginTimeoutID)

      if (!this.emailIsValid) {
        this.loginState = STATE_AVAILABLE
        return
      }

      loginTimeoutID = setTimeout(async () => {
        this.loginState = await verifyLogin(login)
          ? STATE_AVAILABLE
          : STATE_NOT_AVAILABLE
      }, 500)
    },
    'owner.document': function (document) {
      this.documentState = STATE_CHECKING
      clearTimeout(documentTimeoutID)

      if (!this.documentIsValid) {
        this.documentState = STATE_AVAILABLE
        return
      }

      documentTimeoutID = setTimeout(async () => {
        this.documentState = await verifyDocument(document)
          ? STATE_AVAILABLE
          : STATE_NOT_AVAILABLE
      }, 500)
    }
  },
  mounted() {
    setTimeout(() => {
      this.form = this.owner
    }, 1000)
  }
}
</script>
